import { render, staticRenderFns } from "./WidgetProjectStatistics.vue?vue&type=template&id=9f48d2b6&scoped=true"
import script from "./WidgetProjectStatistics.vue?vue&type=script&lang=js"
export * from "./WidgetProjectStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f48d2b6",
  null
  
)

export default component.exports